import React, { Component } from 'react';
export default class Breadcrumbs extends Component {
  render() {
    return (
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="/">Home</a>
          </li>
          {this.props.crumbs &&
            this.props.crumbs.map(crumb => (
              <li
                className={
                  window.location.pathname === crumb.url
                    ? 'breadcrumb-item active'
                    : 'breadcrumb-item'
                }
                aria-current="page"
              >
                {window.location.pathname === crumb.url ? (
                  <span>{crumb.name}</span>
                ) : (
                  <a href={crumb.url}>{crumb.name}</a>
                )}
              </li>
            ))}
        </ol>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs.jsx